import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import { useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { toast } from "react-toastify";
import { AXIOS } from "../../Component/apiHelper";
import { apiList } from "../../Component/apiList";
import { TextField } from "@mui/material";

const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    border: "none",
    boxShadow: 24,
    p: 4,
    borderRadius: 2,
};

const validationSchema = Yup.object({
    Title: Yup.string().required("Title is required"),
    Description: Yup.string().required("Description is required"),
});

export default function IndividualNotificationComponent({ userId, type }) {
    const [open, setOpen] = useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    const formik = useFormik({
        initialValues: {
            Title: "",
            Description: "",
        },
        validationSchema,
        onSubmit: async (values, { resetForm, setSubmitting }) => {
            let f = new FormData();
            f.append("title", values.Title);
            f.append("msg", values.Description);
            f.append("user_id", userId);
            f.append("type", type);
            try
            {
                setSubmitting(true);
                const response = await AXIOS.post(
                    apiList.notification.sentIndividual,
                    f
                );
                if (response?.s === 1)
                {
                    toast.success("Notification sent successfully");
                } else
                {
                    toast.error(response?.m);
                }
                setSubmitting(false);
            } catch (error)
            {
                console.log(error);
                setSubmitting(false);
            }
            resetForm();
            handleClose();
        },
    });

    return (
        <div>
            <Button
                onClick={handleOpen}
                variant="contained"
                sx={{
                    background: `linear-gradient(0deg, #FF602D 8.18%, #DA4312 100%)`,
                    textTransform: "none",
                    color: "#FFF",
                    fontSize: "14px",
                    width: "150px",
                    borderRadius: "12px",
                    // height: "px",
                    "&:hover": { bgcolor: "#F2F2F2" },
                }}
            >
                Send Notification
            </Button>
            <Modal
                open={open}
                onClose={() => {
                    handleClose();
                    formik?.resetForm();
                }}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <Typography
                        id="modal-modal-title"
                        variant="h6"
                        component="h2"
                        style={{
                            color: "#fd5d29", fontWeight: 500, borderBottom: "1px solid #febba550",
                            paddingBottom: "12px",
                        }}
                    >
                        Send Personal Notification
                    </Typography>
                    <form
                        style={{ width: "100%", marginTop: 2 }}
                        onSubmit={formik.handleSubmit}
                    >
                        <Typography
                            sx={{ fontSize: "16px", fontWeight: "500", mb: 0.5, mt: 1 }}
                        >
                            Notification Title
                        </Typography>
                        <TextField
                            type="text"
                            name="Title"
                            fullWidth
                            value={formik.values.Title}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            placeholder="Title"
                            sx={{
                                ".MuiInputBase-root": {
                                    borderRadius: "12px",
                                    background: "#FD5D2914",
                                    color: "#000",
                                    border: "1px solid #FD5D2966",
                                },
                                ".MuiOutlinedInput-input": {
                                    padding: "14px",
                                },

                                "& input[type='password']::-ms-reveal": {
                                    display: "none",
                                },
                                "& input[type='password']::-ms-clear": {
                                    display: "none",
                                },

                                ".MuiOutlinedInput-input:focus": {
                                    outline: "none",
                                },
                                fieldset: {
                                    border: "none",
                                },
                            }}
                        />
                        {formik.touched.Title && formik.errors.Title && (
                            <Typography sx={{ color: "red", fontSize: "14px" }}>
                                {formik.errors.Title}
                            </Typography>
                        )}

                        <Typography
                            sx={{ fontSize: "16px", fontWeight: "500", mt: 2, mb: 0.5 }}
                        >
                            Description
                        </Typography>
                        <TextField
                            fullWidth
                            name="Description"
                            multiline
                            minRows={4}
                            maxRows={6}
                            value={formik.values.Description}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            placeholder="Description"
                            sx={{
                                ".MuiInputBase-root": {
                                    borderRadius: "12px",
                                    background: "#FD5D2914",
                                    color: "#000",
                                    border: "1px solid #FD5D2966",
                                },


                                "& input[type='password']::-ms-reveal": {
                                    display: "none",
                                },
                                "& input[type='password']::-ms-clear": {
                                    display: "none",
                                },

                                ".MuiOutlinedInput-input:focus": {
                                    outline: "none",
                                },
                                fieldset: {
                                    border: "none",
                                },
                            }}
                        />
                        {formik.touched.Description && formik.errors.Description && (
                            <Typography sx={{ color: "red", fontSize: "14px" }}>
                                {formik.errors.Description}
                            </Typography>
                        )}
                        <Box
                            sx={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                width: "100%",
                                mt: 5,
                            }}
                        >
                            <Button
                                type="submit"
                                disabled={formik.isSubmitting}
                                sx={{
                                    width: "300px",
                                    background: `linear-gradient(0deg, #FF602D 8.18%, #DA4312 100%)`,
                                    color: "#fff",
                                    borderRadius: "10px",
                                    height: "45px",
                                    fontSize: "16px",
                                    fontWeight: "600",
                                    textTransform: "none",
                                    "&:hover": {
                                        background: `linear-gradient(0deg, #FF602D 8.18%, #DA4312 100%)`,
                                        opacity: 0.8,
                                    },
                                }}
                            >
                                {formik.isSubmitting ? "Loading..." : "Submit"}
                            </Button>
                        </Box>
                    </form>
                </Box>
            </Modal>
        </div>
    );
}
